import React, { useState } from "react";
import {
  Select,
  MenuItem,
  FormControl,
  FormLabel,
  FormGroup,
  Typography,
  Box,
  TextField,
} from "@material-ui/core";

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';

import CurrencyTextField from '@unicef/material-ui-currency-textfield'

import InfoField from "../components/InfoField";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  "& > *": {
    width: "25ch",
  },

  formControl: {
    margin: theme.spacing(3),
    maxWidth: "25ch",
    minWidth: "25ch",
  },
  formControlsm: {
    maxWidth: "100%",
    minWidth: "100%",
  },
  selectEmpty: {
    margin: theme.spacing(3),
    marginLeft: "-1px",
    maxWidth: "25ch",
    minWidth: "25ch",
  },
  selectEmptySm: {
    marginLeft: -theme.spacing(2),
    maxWidth: "100%",
    minWidth: "100%",
  },
}));

export const SelectForm = (props) => {
  const classes = useStyles();

  const [value, setValue] = useState("");
  const handleChange = (e) => {
    setValue(e.target.value);
  };
  return (
    <FormControl
      error={!!props.field.required && !value}
      required={!!props.field.required}
      component="fieldset"
      variant="outlined"
      style={
        props.mediaquery ? { marginLeft: "-2px", marginRight: "28px" } : {}
      }
      className={
        props.mediaquery ? classes.formControl : classes.formControlsm
      }>
      <FormLabel
        style={{
          color: "black",
          fontWeight: "bold",
          fontSize: "16px",
          margin: props.mediaquery ? "8px 0px 0px 12px" : "8px 0px",
        }}>
        {props.field.label}
        {props.field.info && (
          <InfoField description={props.field.info.description} />
        )}
      </FormLabel>
      <FormGroup>
        <Select
          error={!!props.field.required && !value}
          variant="outlined"
          id={props.field.id}
          value={props.value ? props.value : value}
          fontSize={16}
          onChange={(e) =>
            props.handleChange ? props.handleChange(e) : handleChange(e)
          }
          className={
            props.mediaquery ? classes.formControl : classes.selectEmptySm
          }
          name={props.field.name}>
          {props.field.select_options.map((e) => (
            <MenuItem key={e.value} value={e.value}>
              {e.label}
            </MenuItem>
          ))}
        </Select>
      </FormGroup>
    </FormControl>
  );
};

// export const TextForm = (props) => {
//   const [value, setValue] = useState("");
//   const handleChange = (e) => {
//     const targetValue = e.target.value;
//     if (props.regex) {
//       if (!targetValue || targetValue.match(new RegExp(props.regex))) {
//         setValue(targetValue);
//       }
//     } else {
//       setValue(targetValue);
//     }
//   };
//   const classes = useStyles();
//   return (
//     <FormControl
//       component="fieldset"
//       variant="outlined"
//       className={
//         props.mediaquery ? classes.formControl : classes.formControlsm
//       }>
//       <FormLabel
//         style={{
//           color: "black",
//           fontWeight: "bold",
//           fontSize: "16px",
//           margin: "8px 0px",
//         }}>
//         {props.field.label}
//         {props.field.info && (
//           <InfoField description={props.field.info.description} />
//         )}
//       </FormLabel>
//       <FormGroup>
//         <TextField
//           variant="outlined"
//           value={props.field.mask ? props.field.mask(value) : value}
//           onChange={handleChange}
//           placeholder={props.field.placeholder}
//           name={props.field.name}
//         />
//       </FormGroup>
//     </FormControl>
//   );
// };

export const InputForm = (props) => {
  const [value, setValue] = useState("");
  const handleChange = (e) => {
    const targetValue = e.target.value;
    if (props.regex) {
      if (!targetValue || targetValue.match(new RegExp(props.regex))) {
        setValue(targetValue);
      }
    } else {
      setValue(targetValue);
    }
  };
  const classes = useStyles();
  return (
    <FormControl
      error={(!!props.field.required || props.field.name === 'documento') && !value}
      required={!!props.field.required || props.field.name === 'documento'}
      component="fieldset"
      variant="outlined"
      className={
        props.mediaquery ? classes.formControl : classes.formControlsm
      }>
      <FormLabel
        style={{
          color: "black",
          fontWeight: "bold",
          fontSize: "16px",
          margin: "8px 0px",
        }}>
        {props.field.label}
        {props.field.info && (
          <InfoField description={props.field.info.description} />
        )}
      </FormLabel>
      <FormGroup>
        <TextField
          error={(!!props.field.required || props.field.name === 'documento') && !value}
          variant="outlined"
          value={props.field.mask ? props.field.mask(value) : value}
          onChange={handleChange}
          placeholder={props.field.placeholder}
          name={props.field.name}
          type={props.field.type}
        />
      </FormGroup>
    </FormControl>
  );
};

export const DateForm = (props) => {
  const [value, setValue] = useState(null);
  const classes = useStyles();
  return (
    <FormControl
      error={!!props.field.required && !value}
      required={!!props.field.required}
      component="fieldset"
      variant="outlined"
      className={
        props.mediaquery ? classes.formControl : classes.formControlsm
      }>
      <FormLabel
        style={{
          color: "black",
          fontWeight: "bold",
          fontSize: "16px",
          margin: "8px 0px",
        }}>
        {props.field.label}
        {props.field.info && (
          <InfoField description={props.field.info.description} />
        )}
      </FormLabel>
      <FormGroup>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            inputFormat={props.field.inputFormat || "DD/MM/YYYY"}
            value={value}
            onChange={(newValue) => {
              setValue(newValue);
            }}
            renderInput={(params) => <TextField error={!!props.field.required && !value} id={props.field.id} name={props.field.name} {...params} />}
          />
        </LocalizationProvider>
      </FormGroup>
    </FormControl>
  );
};

export const CurrencyForm = (props) => {
  const [value, setValue] = useState(null);
  const classes = useStyles();
  const handleChange = (e, value) => {
    if (value == "" && e.target.value) {
      setValue(e.target.value);
    } else {
      setValue(value);
    }
  };
  return (
    <FormControl
      error={!!props.field.required && !value}
      required={!!props.field.required}
      component="fieldset"
      variant="outlined"
      className={
        props.mediaquery ? classes.formControl : classes.formControlsm
      }>
      <FormLabel
        style={{
          color: "black",
          fontWeight: "bold",
          fontSize: "16px",
          margin: "8px 0px",
        }}>
        {props.field.label}
        {props.field.info && (
          <InfoField description={props.field.info.description} />
        )}
      </FormLabel>
      <FormGroup>
        <CurrencyTextField
          error={!!props.field.required && !value}
          id={props.field.id}
          placeholder="0,00"
          variant="outlined"
          value={value}
          currencySymbol={props.field.currencySymbol || "R$"}
          minimumValue="0"
          outputFormat="string"
          decimalCharacter={props.field.decimalCharacter || ","}
          digitGroupSeparator={props.field.digitGroupSeparator || "."}
          onChange={handleChange}
        />
      </FormGroup>
    </FormControl>
  );
};

export const Tags = (props) => {
  return (
    <Box
      component={"div"}
      display={{ xs: "block", sm: "block", md: "inline" }}
      m={1}
      fontSize={12}
      borderRadius={16}
      bgcolor="#aaa"
      color="#fff"
      textAlign="center"
      style={{ padding: "1px 6px" }}>
      {props.description}
    </Box>
  );
};
